import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { isQueryMountedWithData } from '@/hooks/api/sse/utils.ts';
import { ExtractEntities, ExtractEntity } from '@/types/extract.ts';
import { STEP_EXECUTION_EXTRACT_ENTITIES_KEY } from '@/utils/queryKeys.ts';

const useInvalidateExtractEntity = (automationId: string) => {
  const queryClient = useQueryClient();

  return useCallback(
    (extractEntity: ExtractEntity, stepExecutionId: string): unknown[][] => {
      const queryKey = STEP_EXECUTION_EXTRACT_ENTITIES_KEY(automationId, stepExecutionId);

      const queryIsMountedWithData = isQueryMountedWithData(queryClient, queryKey);
      if (!queryIsMountedWithData) {
        return [queryKey];
      }

      queryClient.setQueryData<ExtractEntities>(queryKey, (data) => {
        const currentResults = data?.results ?? [];

        const updatedResults = currentResults.filter((item) => {
          const isSameId = item.id === extractEntity.id;
          const isSameStepIndex = item.index === extractEntity.index;
          return !isSameId && !isSameStepIndex;
        });

        updatedResults.push(extractEntity);
        updatedResults.sort((a, b) => a.index - b.index);

        return { results: updatedResults };
      });

      return [];
    },
    [automationId, queryClient],
  );
};

export default useInvalidateExtractEntity;
